const TutorRegistrationProgressBar = ({ step }) => {
  return (
    <div className="w-full h-4 bg-gray-200 rounded-2xl mb-3 overflow-hidden md:max-w-1/2 md:mx-auto">
      <div
        className="h-full bg-(--primary-color-light) transition-all duration-300"
        style={{ width: `${(step / 7) * 100}%` }}
      ></div>
    </div>
  );
};

export default TutorRegistrationProgressBar;
